import { logout } from "@application/features/auth/authSlice";
import { refreshTokenAsync } from "@application/features/auth/authThunk";
import LocalStorageService from "@application/features/Common/local-storage-service";
import axios from "axios";
import i18n from "../i18n";
const baseURL = process.env.REACT_APP_API_BASE_URL;
let refreshing_token = null;
export const vdkHappinessPortalApi = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});
vdkHappinessPortalApi.interceptors.request.use(async (config) => {
    if (config.headers && typeof config.headers.set === "function") {
        config.headers.set("Accept-Language", i18n.language || "en");
    }
    const accessToken = LocalStorageService.getAccessToken();
    const msAccessToken = LocalStorageService.getMSAccessToken();
    if (accessToken == null && config.url == "auth/refresh") {
        const { store } = await import("../application/store");
        store.dispatch(logout());
        const controller = new AbortController();
        const cfg = {
            ...config,
            singal: controller.signal,
        };
        controller.abort("Refresh token request cancelled");
        return cfg;
    }
    if (config.url != "auth/refresh" && config.url != "account/authenticate") {
        if (config.headers) {
            config.headers.set("Authorization", `Bearer ${msAccessToken}`);
            config.headers.set("XAuthorization", `Bearer ${accessToken}`);
        }
    }
    return config;
});
vdkHappinessPortalApi.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const config = error.config;
    if (error.response && error.response.status == 401 && !config.retry) {
        if (error.config.url == "account/authenticate" ||
            error.config.url == "account/forget-password") {
            return Promise.reject(error);
        }
        else if (error.config.url == "auth/refresh" || error.config.retry) {
            const { store } = await import("../application/store");
            store.dispatch(logout());
        }
        else {
            config._retry = true;
            try {
                refreshing_token = refreshing_token
                    ? refreshing_token
                    : refreshToken();
                await refreshing_token;
                return vdkHappinessPortalApi(config);
            }
            catch (err) {
                refreshing_token = null;
                return Promise.reject(err);
            }
        }
    }
    refreshing_token = null;
    return Promise.reject(error);
});
async function refreshToken() {
    if (!refreshing_token) {
        const { store } = await import("../application/store");
        refreshing_token = store.dispatch(refreshTokenAsync()).unwrap();
    }
    return refreshing_token;
}
